const MONEY_FACTOR = 100;

export const calculateWholeShareAllocation = (amount, sharePrice) => {
  const amountUnits = Math.round((Number(amount) || 0) * MONEY_FACTOR);
  const sharePriceUnits = Math.round((Number(sharePrice) || 0) * MONEY_FACTOR);

  if (amountUnits <= 0 || sharePriceUnits <= 0) {
    return {
      wholeShares: 0,
      amountInvested: 0,
      dividendRemainder: Math.max(amountUnits, 0) / MONEY_FACTOR,
    };
  }

  const wholeShares = Math.floor(amountUnits / sharePriceUnits);
  const investedUnits = wholeShares * sharePriceUnits;

  return {
    wholeShares,
    amountInvested: investedUnits / MONEY_FACTOR,
    dividendRemainder: (amountUnits - investedUnits) / MONEY_FACTOR,
  };
};
